import { applyMiddleware, compose, createStore } from 'redux'
import { responsiveStoreEnhancer } from 'redux-responsive'
import thunk from 'redux-thunk'

import reducer from './reducer'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose;

const storeInit = () => {
  if (!window._store) {
    const store = createStore(
      reducer,
      composeEnhancers(
        responsiveStoreEnhancer,
        applyMiddleware(...[thunk]),
        window.devToolsExtension ? window.devToolsExtension() : f => f,
      ),
    )

    window._store = store
  }

  return window._store
}

export default storeInit()
